export default "__VITE_ASSET__DxWkmqD7__"